/* eslint-disable max-lines-per-function, max-statements */
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import useToggle from "@bluframe/grapple/useToggle";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import useAutosuggestOptions from "hooks/useAutosuggestOptions";
import useUser from "hooks/useUser";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Item from "./Item";
const { vendors: { GET_STORES, GET_STORE_BY_ID, SEARCH_VENDORS } } = queries;
const { vendors: { DELETE_STORE, UPDATE_STORE } } = mutations;
const usePrepareComponent = () => {
    const [isEditing, toggleIsEditing] = useToggle();
    const history = useHistory();
    const params = useParams();
    const [selectedVendorId, setSelectedVendorId] = useState();
    const { isAdmin, isEditor } = useUser();
    const { data, loading } = useQuery(GET_STORE_BY_ID, {
        fetchPolicy: "network-only",
        onCompleted: (completedData) => {
            setSelectedVendorId((prev) => prev ?? completedData.getStoreById.vendor.id);
        },
        variables: { id: params.id }
    });
    const [updateStore, { loading: isSaveLoading }] = useMutation(UPDATE_STORE, {
        refetchQueries: [{ query: GET_STORE_BY_ID, variables: { id: params.id } }]
    });
    const [deleteStore] = useMutation(DELETE_STORE, {
        refetchQueries: [{ query: GET_STORES }]
    });
    const [searchVendors, { data: searchVendorsData, loading: searchVendorsLoading }] = useLazyQuery(SEARCH_VENDORS);
    const onCancel = () => {
        toggleIsEditing();
    };
    const onEdit = () => {
        toggleIsEditing();
    };
    const onPublishToggle = () => {
        updateStore({
            variables: {
                id: params.id,
                storeUpdateInput: { isPublished: !data?.getStoreById.isPublished }
            }
        });
    };
    const onSave = (storeUpdate) => {
        if (!params.id || !storeUpdate.vendorId)
            return;
        updateStore({
            onCompleted: () => toggleIsEditing(),
            variables: {
                id: params.id,
                storeUpdateInput: {
                    ...storeUpdate,
                    vendorId: storeUpdate.vendorId
                }
            }
        });
    };
    const onDelete = () => {
        if (!params.id)
            return;
        deleteStore({
            onCompleted: () => history.push("/vendors/stores"),
            variables: { id: params.id }
        });
    };
    const onSelectVendorId = (id) => {
        setSelectedVendorId(id);
    };
    const onGetVendorsSuggestions = ({ inputValue }) => {
        searchVendors({
            variables: {
                searchVendorsInput: { name: inputValue }
            }
        });
    };
    /**
     * Generates options for the vendor autosuggest input.
     */
    const autosuggestVendors = useAutosuggestOptions({
        selected: data?.getStoreById?.vendor,
        suggestions: searchVendorsData?.searchVendors
    });
    return {
        isAdmin,
        isEditing,
        isEditor,
        isSaveLoading,
        isVendorsSuggestionsLoading: searchVendorsLoading,
        item: data?.getStoreById,
        loading,
        onCancel,
        onDelete,
        onEdit,
        onGetVendorsSuggestions,
        onPublishToggle,
        onSave,
        onSelectVendorId,
        selectedVendorId,
        vendors: autosuggestVendors
    };
};
export default prepareComponent(usePrepareComponent)(Item);
